import { useMemo, useState } from "react";
import Image from "./image";
import ImageModal from "./ImageModal";

const CHUNK_SIZE = 6

export const Gallery = (props) => {
  const [isOpen, setIsOpen] = useState(false)
  const [srcImage, setSrcImage] = useState(null)
  const [chunksAmount, setChunksAmount] = useState(1)

  const images = useMemo(() => {
    if (!props.data?.Images) return []
    const maxImages = chunksAmount * CHUNK_SIZE
    return props.data.Images.slice(0, maxImages)
  }, [chunksAmount, props.data?.Images])

  const hasMoreImages = useMemo(() => {
    if (!props.data?.Images) return false
    return images.length < props.data.Images.length
  }, [images.length, props.data?.Images])

  const handleClick = (src) => {
    setIsOpen(true)
    setSrcImage(src)
    document.body.style.overflow = 'hidden'
  }

  const handleLoadMore = () => {
    setChunksAmount(prev => prev + 1)
  }

  return (
    <div id='portfolio' className='text-center'>
      <div id="installations">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <img src="img/portada-residencial.jpg" className="img-responsive" alt="" />
            </div>
            <div className="col-xs-12 col-md-6">
              <div className="installations-text">
                <h2>Instalaciones</h2>
                <p>{props.data ? props.data.paragraph : "loading..."}</p>
                <p>{props.data ? props.data.paragraph2 : "loading..."}</p>
                <p>{props.data ? props.data.paragraph3 : "loading..."}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='container'>
        <div className='section-title'>
          <h2>Galería</h2>
        </div>
        <div className='row'>
          {images.length > 0
            ? images.map((d, i) => (
              <div className='col-sm-6 col-md-4 col-lg-4' key={d.largeImage} >
                <Image
                  className='gallery-img'
                  title={d.title}
                  largeImage={d.largeImage}
                  handleClick={() => handleClick(i)}
                  withHover={true}
                />
              </div>
            ))
            : 'Loading...'}
        </div>

        {/* Botón Ver más */}
        {hasMoreImages && (
          <div className="row">
            <div className="col-xs-12" style={{ marginTop: '30px' }}>
              <button
                className="btn btn-custom btn-lg"
                onClick={handleLoadMore}
              >
                Ver más
              </button>
            </div>
          </div>
        )}
      </div>
      <ImageModal data={props.data} isOpen={isOpen} setIsOpen={setIsOpen} srcImage={srcImage} />
    </div>
  )
}